import React from 'react';
import Section1 from './Sections/section1';
import Section2 from './Sections/section2';
import Section3 from './Sections/section3';
import Section4 from './Sections/section4';

export default class App extends React.Component {
  render() {
    return (
      <div className="">
        <div className="container-fluid sec1" />
        <Section1/>
        <div className="container-fluid sec2" />        
        <Section2/>
        <div className="container-fluid sec3">
          <div className="container">
            <div className= "apptitle1 mx-auto mb-3 mt-5">
              <h3>DONATIONS OVER TIME</h3>
              <div className="desc">
                <p>Who’s a loyal party donor? How much do elections impact donations? Use this tool and the drop-down menus below to track trends over time. For example, select “Alberta” and “New Democratic Party” from the drop-down menus to see the spike in contributions after the party won a majority government in 2015.</p>
              </div>
            </div>
            </div>
          </div>
        <Section3/>
        <div className="container-fluid sec4"/>        
        <Section4/>
        <section className="container footer mb-5">
          <div className="row d-flex justify-content-between align-items-end" style={{borderBottom: "1px solid #ddd"}}>          
            
            
            <div className="col-6 col-sm-4 p-2 hidden-xs-down">
              <div className="titlesCont">
                <a href="http://postmedia.com/" target="_blank">
                  <img className="logo" src="./assets/postmedia-LOGO.png" alt="np logo" height="35px"/>
                </a>
              </div>
            </div>
            <div className="col-12 col-sm-4 text-center">
              <img src="assets/footer_Votingimage.jpg"/>
            </div>
            <div className="col-6 col-sm-4 p-2 text-right hidden-xs-down">
              <a href="https://www.qlik.com" target="_blank">
                <img className="logo" src="./assets/Analytics-By-Qlik-Mark-Horizontal-noRule_RGB.png" alt="Qlik logo" height="35px"/>
              </a>
            </div>
            
           
          </div>
          <div className="row hidden-sm-up">
            <div className="col-6 p-2">
                <div className="titlesCont">
                  <a href="http://www.nationalpost.com" target="_blank">
                    <img className="logo" src="./assets/np_logo_full.svg" alt="np logo"/>
                  </a>
                </div>
              </div>
              <div className="col-6 p-2 text-right">
              <a href="https://www.qlik.com" target="_blank">
                <img className="logo" src="./assets/Analytics-By-Qlik-Mark-Horizontal-noRule_RGB.png" alt="Qlik logo" height="35px"/>
              </a>
            </div>
          </div>
          <div style={{fontSize:"10px", textAlign: "center", margin: "0 auto"}}>
          Data sources: <a href="http://www.elections.ca">Elections Canada</a>, <a href="http://elections.bc.ca/">Elections British Columbia</a>, <a href="http://www.elections.ab.ca">Elections Alberta</a>, <a href="http://www.electionsmanitoba.ca/en">Elections Manitoba</a>, <a href="http://www.elections.sk.ca">Elections Saskatchewan</a>, <a href="http://www.elections.on.ca/en.html">Elections Ontario</a>, <a href="http://www.electionsquebec.qc.ca/english">Elections Quebec</a>, <a href="http://www.electionsnb.ca">Elections New Brunswick</a>, <a href="http://electionsnovascotia.ca">Elections Nova Scotia</a>, <a href="http://www.elections.gov.nl.ca/elections">Elections Newfoundland and Labrador</a>, <a href="http://www.electionspei.ca">Elections Prince Edward Island</a>, <a href="http://www.elections.nu.ca">Elections Nunavut</a>, <a href="http://electionsyk.ca/en">Elections Yukon</a>, and <a href="http://www.electionsnwt.ca">Elections Northwest Territories</a>. <a href="http://www.icons8.com">Icons</a>
          </div>
        </section>
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./components/App.js